var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1178_10452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99023 15.71H1.65023C0.600228 15.71 -0.0497722 14.58 0.470228 13.67L4.14023 7.32001L7.81023 0.970006C8.33023 0.0600061 9.64023 0.0600061 10.1702 0.970006L13.8402 7.32001L17.5102 13.67C18.0302 14.58 17.3802 15.71 16.3302 15.71H8.99023Z",
    fill: "#FEB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3201 16H1.65012C1.05012 16 0.520117 15.69 0.220117 15.18C-0.0798828 14.66 -0.0798828 14.05 0.220117 13.53L7.56012 0.82C7.86012 0.3 8.39012 0 8.99012 0C9.59012 0 10.1201 0.31 10.4201 0.82L17.7601 13.53C18.0601 14.05 18.0601 14.66 17.7601 15.18C17.4601 15.7 16.9301 16 16.3301 16H16.3201ZM8.99012 0.57C8.60012 0.57 8.25012 0.77 8.06012 1.11L0.720117 13.82C0.530117 14.16 0.530117 14.56 0.720117 14.9C0.910117 15.24 1.26012 15.44 1.65012 15.44H16.3201C16.7101 15.44 17.0601 15.24 17.2501 14.9C17.4401 14.56 17.4401 14.16 17.2501 13.82L9.92012 1.11C9.73012 0.77 9.38012 0.57 8.99012 0.57Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01002 1.87C8.21002 1.54 8.58002 1.34 8.99002 1.34C9.40002 1.34 9.77002 1.54 9.97002 1.87L14.96 9.88L9.90002 1.12C9.71002 0.789996 9.37002 0.589996 8.99002 0.589996C8.61002 0.589996 8.27002 0.789996 8.08002 1.12L3.02002 9.88L8.01002 1.87Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.12012 12.28C8.12012 11.99 8.20012 11.77 8.35012 11.62C8.50012 11.47 8.72012 11.4 9.00012 11.4C9.28012 11.4 9.49012 11.48 9.64012 11.63C9.79012 11.78 9.86012 12 9.86012 12.28C9.86012 12.56 9.79012 12.77 9.64012 12.94C9.49012 13.11 9.28012 13.18 9.01012 13.18C8.74012 13.18 8.52012 13.1 8.37012 12.95C8.22012 12.8 8.14012 12.57 8.14012 12.29L8.12012 12.28ZM9.51012 10.42H8.50012L8.23012 4.45999C8.21012 4.01999 8.56012 3.64999 9.00012 3.64999C9.44012 3.64999 9.79012 4.01999 9.77012 4.45999L9.51012 10.42Z",
    fill: "#1A202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1178_10452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.97,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTwo);
export default __webpack_public_path__ + "static/media/WarningTwo.afc1a7abe99a68e5f8940daae4e8cf13.svg";
export { ForwardRef as ReactComponent };